import ready from 'utils/ready';
import {on} from 'utils/events';
import {$, $$} from 'utils/selector';

ready().then(() => {

  const className = '.slider-product';
  const elements = $$(className);

  if (elements.length > 0) {

    Promise.all([
      import (/* webpackChunkName: "slider" */'swiper/core'),
      import (/* webpackChunkName: "slider" */'./slider.css'),
      import (/* webpackChunkName: "slider" */'swiper/swiper-bundle.css')
    ]).then(modules => {

      var Swiper = modules[0].default;
      var Navigation = modules[0].Navigation;
      var Pagination = modules[0].Pagination;
      var Thumbs = modules[0].Thumbs;
      var Autoplay = modules[0].Autoplay;
      var EffectFade = modules[0].EffectFade;
      var Keyboard = modules[0].Keyboard;
      var Mousewheel = modules[0].Mousewheel;

      Swiper.use([Navigation, Pagination, Thumbs, Autoplay, EffectFade, Keyboard, Mousewheel]);

      elements.forEach(element => {

        var thumbs = new Swiper(".slider-product-thumbs", {
          spaceBetween: 10,
          slidesPerView: 3,
          direction: 'vertical',
          watchOverflow: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          mousewheel: {
          },
          // freeMode: true,
        });


        var main = new Swiper (element, {
          // autoHeight: true,
          // loop: true,

          keyboard: {
            enabled: true,
          },

          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },

          speed: 100,
          watchOverflow: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          preventInteractionOnTransition: true,
          autoplay: {
            delay: 4000,
          },

          pagination: {
            // dynamicBullets: true,
            clickable: true,
            el: '.swiper-pagination',
          },

          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

          thumbs: {
            swiper: thumbs,
          },
        });

        main.on('slideChange', function(swiper){
          $('#imagecaption').innerHTML = "Symbolfoto: " + $('figcaption', swiper.slides[swiper.activeIndex]).innerHTML;
        });

      });

    });

  }

});
